import React, { useEffect } from "react";

import AOS from "aos";
import "aos/dist/aos.css";
import { FaArrowRight, FaArrowsRotate, FaChartLine } from "react-icons/fa6";
import { GiOnTarget, GiTakeMyMoney } from "react-icons/gi";
import { TiDocumentText } from "react-icons/ti";
import { AiFillHourglass } from "react-icons/ai";
const Whyus = () => {

  useEffect(() => {
    AOS.init({
      delay: 100, // values from 0 to 3000, with step 50ms
      duration: 600, // values from 0 to 3000, with step 50ms
      easing: "ease", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false,
    });
  }, []);



  return (
    <>
    <section style={{backgroundColor: "#edecea"}} className="py-5 mt-5">
     
            <div className="container">
              <h2 className="heading text-center " >
              Fund Overview
              </h2>
              <div className="row gy-4 justify-content-center mt-2">
                <div className="col-lg-2 col-md-4 text-center px-lg-2">
                 <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
                 <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
                 <FaArrowsRotate  className="fs-3"/>
                 </div>
                  <h6 className="text-center">Fund Structure</h6>
                  <p className="text-center small-desc mb-0">Open Ended</p>
                 </div>
                </div>
                <div className="col-lg-2 col-md-4 text-center  px-lg-2">
               <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
               <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
               <GiTakeMyMoney className="fs-3"/>
               </div>
                  <h6 className="text-center mb-1">Minimum Investment</h6>
                  <p className="text-center small-desc mb-0">Rs. 1Crore</p>
               </div>
                </div>
                <div className="col-lg-2 col-md-4 text-center  px-lg-2">
               <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
               <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
               <FaChartLine className="fs-3"/>
               </div>
                  <h6 className="text-center mb-1">Style</h6>
                  <p className="text-center small-desc mb-0">Multi-cap Long Only Fund</p>
               </div>
                </div>
                <div className="col-lg-2 col-md-4 text-center  px-lg-2">
               <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
               <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
               <TiDocumentText className="fs-3"/>
               </div>
                  <h6 className="text-center mb-1">Portfolio Universe</h6>
                  <p className="text-center small-desc mb-0">40-50 Stocks</p>
               </div>
                </div>
                <div className="col-lg-2 col-md-4 text-center  px-lg-2">
               <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
               <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
               <AiFillHourglass className="fs-3"/>
               </div>
                  <h6 className="text-center mb-1">Investment Horizon</h6>
                  <p className="text-center small-desc mb-0">Long Term</p>
               </div>
                </div>
                <div className="col-lg-2 col-md-4 text-center  px-lg-2">
               <div className="border overview_card_box rounded-2 flex flex-column align-items-center justify-content-center p-3">
               <div className="bg-white circular_icon_box d-flex align-items-center justify-content-center rounded-circle mx-auto mb-2">
               <GiOnTarget className="fs-3"/>
               </div>
                  <h6 className="text-center mb-1">Investment Style</h6>
                  <p className="text-center small-desc">3M Strategy</p>
               </div>
                </div>
              </div>
              </div>
            
      </section>
   
    </>
  );
};

export default Whyus;
